export const USER_GROUPS_QUERY_KEY = "user-groups";
export const ORG_USERS_QUERY_KEY = "org-users";
export const MQTT_CONFIG_QUERY_KEY = "mqtt-config";
export const ACTIVE_ORG_COOKIE_NAME = "aoc-active-org";